import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companyService: {},
  vulnerabilityScans: {},
  selfAssessmentTools: {},
  assessmentReportQueue: {},
};

const redirectSlice = createSlice({
  name: 'redirect',
  initialState,
  reducers: {
    setCompanyServiceError: (state, action) => {
      state.companyService.error = action.payload;
    },
    setVulnerabilityScansError: (state, action) => {
      state.vulnerabilityScans.error = action.payload;
    },
    setSelfAssessmentToolsError: (state, action) => {
      state.selfAssessmentTools.error = action.payload;
    },
    setAssessmentReportQueueError: (state, action) => {
      state.assessmentReportQueue.error = action.payload;
    },
    setCompanyService: (state, action) => {
      state.companyService = action.payload;
    },
    setVulnerabilityScans: (state, action) => {
      state.vulnerabilityScans = action.payload;
    },
    setSelfAssessmentTools: (state, action) => {
      state.selfAssessmentTools = action.payload;
    },
    setAssessmentReportQueue: (state, action) => {
      state.assessmentReportQueue = action.payload;
    },
    setResetRedirect: () => {
      return initialState;
    },
  },
});

export const {
  setCompanyServiceError,
  setVulnerabilityScansError,
  setSelfAssessmentToolsError,
  setAssessmentReportQueueError,
  setCompanyService,
  setVulnerabilityScans,
  setSelfAssessmentTools,
  setAssessmentReportQueue,
  setResetRedirect,
} = redirectSlice.actions;

export default redirectSlice.reducer;
